import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts';
import { isDealerMember } from '../../utils';

/** /reports: a dealer's Reports section is the dealer list; staff land on Floor Plans. */
const ReportsIndexRedirect: React.FC = () => {
  const { user } = useAuth();
  return (
    <Navigate
      to={isDealerMember(user) ? '/reports/dealer-reports' : '/reports/floor-plans'}
      replace
    />
  );
};

export default ReportsIndexRedirect;
